/* eslint-env worker */
/* global ImageDecoder */
// Decodes the frames of an animated image off the main thread, for
// RecorderCanvasImage (loaded as raw source and started from a Blob URL).
// In:  { buf, type } once, then optionally { cancel: true }.
// Out: { kind: "meta", repetitionCount, frameCount }, then one
//      { kind: "frame", frame, complete } per frame (the VideoFrame is
//      transferred), then { kind: "end" } — or { kind: "error", message }.
// A RangeError "frame index out of range" is the end of the file, not an error.
const MAX_FRAMES = 4096;
let stop = false;
let decoder = null;

self.onmessage = async (e) => {
  const m = e.data;
  if (m.cancel) {
    stop = true;
    return;
  }
  try {
    decoder = new ImageDecoder({ data: m.buf, type: m.type });
    await decoder.completed;
    const t = decoder.tracks.selectedTrack;
    self.postMessage({
      kind: "meta",
      repetitionCount: t && t.repetitionCount,
      frameCount: t && t.frameCount,
    });
    for (let i = 0; i < MAX_FRAMES && !stop; i++) {
      let r;
      try {
        r = await decoder.decode({ frameIndex: i });
      } catch (err) {
        if (err && err.name === "RangeError") break;
        throw err;
      }
      if (stop) {
        r.image.close();
        break;
      }
      const complete = r.complete !== false;
      self.postMessage({ kind: "frame", frame: r.image, complete }, [r.image]);
      if (!complete) break;
    }
    if (!stop) self.postMessage({ kind: "end" });
  } catch (err) {
    if (!stop) self.postMessage({ kind: "error", message: String((err && err.message) || err) });
  }
  try {
    if (decoder) decoder.close();
  } catch (_) {
    /* already closed */
  }
};
